import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ProductBatch, ProductBatchRequest } from "../../../../service/model/store.model";
import { Box, Button, Dialog, DialogTitle, Grid } from "@mui/material";
import FormField from "../../../../components/form-controls/form-field";
import theme from "../../../../app/app-theme";
import FormCloseButton from "../../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";

interface ProductBatchFormProps {
    readonly productBatch?: ProductBatch
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: ProductBatchRequest) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const ProductBatchForm: React.FC<ProductBatchFormProps> = ({ productBatch, editable, onClose, onSubmit }) => {
    const schema = yup.object().shape({
        receivedDate: yup.string()
            .required(),
        batchCode: yup.string(),
        costPrice: yup.number(),
        sellingPrice: yup.number(),
        quantityReceived: yup.number(),
        expiryDate: yup.string(),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitHandler = (data: any) => {
        onSubmit(data as ProductBatchRequest)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Product Batch Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}> 
                        <FormField>
                            <FormTextField
                                id="receivedDate"
                                label="Received Date"
                                name="receivedDate"
                                type="date"
                                defaultValue={productBatch?.receivedDate ?? new Date().toISOString().slice(0, 10)}
                                errorMessage={errors.receivedDate?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="batch-code"
                                label="Batch Code"
                                name="batchCode"
                                defaultValue={productBatch?.batchCode}
                                errorMessage={errors.batchCode?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="costPrice"
                                label="Unit Cost"
                                name="costPrice"
                                type="number"
                                defaultValue={productBatch?.costPrice ?? 0}
                                errorMessage={errors.costPrice?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="sellingPrice"
                                label="Selling Price"
                                name="sellingPrice"
                                type="number"
                                defaultValue={productBatch?.sellingPrice ?? 0}
                                errorMessage={errors.sellingPrice?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="quantityReceived"
                                label="Quantity Received"
                                name="quantityReceived"
                                type="number"
                                defaultValue={productBatch?.quantityReceived ?? 0}
                                errorMessage={errors.quantityReceived?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="expiryDate"
                                label="Expiry Date"
                                name="expiryDate"
                                type="date"
                                defaultValue={productBatch?.expiryDate}
                                errorMessage={errors.expiryDate?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default ProductBatchForm;